import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
const disconnectInstitution = async (itemId: string) => {
  await api.delete(apiConfig.routes.wallet.pluggy.item(itemId));
};
export const useDisconnectInstitution = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: disconnectInstitution,
    onSettled: () => {
      [['wallet', 'summary'], ['wallet', 'institutions'], ['wallet', 'connectors'], ['consolidator', 'wallet', 'optimizer', 'status'], ['wallet', 'investments'], ['wallet', 'investments', 'categories'], ['wallet', 'investments', 'institutions'], ['wallet', 'optimizer', 'status']].forEach(key => {
        queryClient.invalidateQueries({
          queryKey: key
        });
      });
    }
  });
};